import * as React from 'react';
import styled from 'styled-components';

import { ListPluginBaseProps } from '../types';

const Main = styled.li``;

interface ListItemElementProps extends ListPluginBaseProps {}

export const ListItemElement = (props: ListItemElementProps) => {
  const { children, attributes } = props;
  return (
    <Main {...attributes} className="list-item-element">
      {children}
    </Main>
  );
};
